import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/pages/Home'
import LoginPage from '@/pages/Login'

import CarPage from '@/pages/Car'
import CarsPage from '@/pages/Cars'
import PhotoAdminPage from '@/pages/CarPhotoAdmin'

import BlogPage from '@/components/blog/PageBlog'
import ArticlePage from '@/components/blog/PageArticle'

Vue.use(Router)

export default new Router({

  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage,
      meta: { requiresAdmin: false, requiresDealer: false, scrollTo: 'top' }
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage,
      meta: { requiresAdmin: false, requiresDealer: false, scrollTo: '#page-login' }
    },

    /* ****** Cars ****** */
    {
      path: '/cars',
      name: 'Cars',
      component: CarsPage,
      meta: { requiresAdmin: false, requiresDealer: false, scrollTo: '#page-cars' }
    },
    {
      path: '/car/:id',
      name: 'Car',
      component: CarPage,
      meta: { requiresAdmin: false, requiresDealer: false, scrollTo: '#page-car' }
    },
    {
      path: '/car-photos/:id',
      name: 'CarPhotos',
      component: PhotoAdminPage,
      meta: { requiresAdmin: false, requiresDealer: true, scrollTo: '#page-car-photo-admin' }
    },

    /* ****** Blog ****** */

    {
      path: '/article/:id',
      name: 'Article',
      component: ArticlePage,
      meta: { requiresAdmin: false, requiresDealer: false, scrollTo: '#page-article' }
    },
    {
      path: '/blog/',
      name: 'Blog',
      component: BlogPage,
      meta: { requiresAdmin: false, requiresDealer: false, scrollTo: '#page-blog' }
    }

  ],

  scrollBehavior (to, from, savedPosition) {
    if (to.matched.some(record => record.meta.scrollTo === 'top')) {
      return { x: 0, y: 0 }
    }
    return { selector: to.meta.scrollTo }
  }

})



// WEBPACK FOOTER //
// ./src/router/index.js